import HomePage from './pages'
import './App.css'

function App() {
  return (
    <div className="app">
      <HomePage />
    </div>
  )
}

export default App
